import React from 'react';
import { Card } from '../components/ui/card';
import { FileText, BookOpen, Award, ExternalLink } from 'lucide-react';
import { Button } from '../components/ui/button';
import SEO from '../components/SEO';

const Resources = () => {
  return (
    <main className="pt-24 bg-[#FDFDFB]">
      <SEO 
        title="Patient Resources & Education"
        description="Access patient forms, intake paperwork, educational resources, and professional verification information."
        keywords="patient forms, intake paperwork, mental health resources, professional verification"
      />

      <section className="py-16 bg-gradient-to-b from-[#f7f4f0] to-[#FDFDFB]">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center mb-12">
            <h1 className="text-5xl font-bold text-[#7a8a72] mb-6">Patient Resources & Education</h1>
            <p className="text-xl text-[#3a3a3a]">
              Everything you need for your care journey
            </p>
          </div>

          <div className="max-w-5xl mx-auto space-y-8">
            <Card className="p-8 bg-white border-[#d4cec5] hover:shadow-lg transition-all">
              <div className="flex items-start gap-6">
                <FileText className="text-[#7a8a72] flex-shrink-0" size={40} />
                <div className="flex-1">
                  <h2 className="text-2xl font-bold text-[#7a8a72] mb-3">Patient Forms & Intake</h2>
                  <p className="text-[#3a3a3a] mb-4">
                    Complete your intake paperwork before your first appointment. All forms are secure and HIPAA-compliant.
                  </p>
                  <a
                    href="https://www.optimantra.com/optimus/om/patient/login?accessPoint=MlVmVjFUQjE4cUhlMW5sTm9sT3VvZz09"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Button className="bg-[#7a8a72] hover:bg-[#6a7a62] text-white">
                      Access Patient Portal
                      <ExternalLink className="ml-2" size={16} />
                    </Button>
                  </a>
                </div>
              </div>
            </Card>

            <Card className="p-8 bg-white border-[#d4cec5] hover:shadow-lg transition-all">
              <div className="flex items-start gap-6">
                <BookOpen className="text-[#7a8a72] flex-shrink-0" size={40} />
                <div className="flex-1">
                  <h2 className="text-2xl font-bold text-[#7a8a72] mb-3">Educational Resources</h2>
                  <p className="text-[#3a3a3a] mb-4">
                    Learn more about mental health conditions, treatment options, and self-care strategies.
                  </p>
                  <a href="/mental-health-education">
                    <Button variant="outline" className="border-[#7a8a72] text-[#7a8a72] hover:bg-[#7a8a72] hover:text-white">
                      View Education Center
                    </Button>
                  </a>
                </div>
              </div>
            </Card>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Resources;